import React, { useEffect, useRef, useState, useContext, createContext } from 'react';
import { Button, Form, Input, Row, Col, Select, Typography, DatePicker, TimePickerForForm, message, Modal, InputNumber, MainModal, useProTableOt, ProTableOt, Accordion, AccordionItem, AccordionTrigger, AccordionContent, UploadAudio, UploadImg } from "../ui/ot";
import dayjs from "dayjs";
import { useTranslation } from 'react-i18next';
import { useClassSetting } from "./controller/class_setting_controller"
const LanguageContext = createContext(null)

const ClassSettingOverView = ({
    keyPrefix = "shift_management.class_setting_overview",
    defaultValue = {},
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    customColumns = [],
    customFormItems = () => { },
    extraActionRender = () => { },
    toolBarRender = (tools) => ([...tools]),
    propsOnFinish = () => { },
    propsOnBefore = () => { },
    propsOnValuesChange = () => { },
    propsShowKeys = [
        { key: "record_id", name: "record_id", hidden: false, require: false },
        { key: "class_id", name: "class_id", hidden: false, require: false },
        { key: "class_name", name: "class_name", hidden: false, require: false },
        { key: "class_working_start_time", name: "class_working_start_time", hidden: false, require: false },
        { key: "class_working_end_time", name: "class_working_end_time", hidden: false, require: false },
        { key: "class_parent_id", name: "class_parent_id", hidden: false, require: false },
        { key: "action", name: "action", hidden: false, require: false },
    ],
}) => {
    const { t } = useTranslation("translation", { keyPrefix });
    const defaultColumns = [
        {
            title: `${t('class_serial')}`,
            dataIndex: 'class_id',
            key: 'class_id',
            sorter: true,
            align: "center",
            render: (text, record, index) => {
                return record?.key || index
            }
        },
        {
            title: `${t('class_name')}`,
            dataIndex: 'class_name',
            key: 'class_name',
            align: "center",
            sorter: true,
        },
        {
            title: `${t('class_working_start_time')}`,
            dataIndex: 'class_working_start_time',
            key: 'class_working_start_time',
            align: "center",
            sorter: true,
            // title: '上班時間',
        },
        {
            title: `${t('class_working_end_time')}`,
            dataIndex: 'class_working_end_time',
            key: 'class_working_end_time',
            align: "center",
            sorter: true,
            // title: '下班時間',
        },
    ];
    const columns = [
        ...customColumns,
        ...defaultColumns.filter(column => propsShowKeys.some(keyObj => keyObj.key === column.key && keyObj.hidden !== true)),
    ]
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])

    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [form] = Form.useForm();
    const [axiosMode, setAxiosMode] = useState("get")

    const handleAddRow = () => {
        setAxiosMode("post")
        setModalOpen(true)
        form.resetFields()
    }
    const handleEditRow = (record) => {
        setAxiosMode("patch")
        setModalOpen(true)

        form.resetFields()
        form.setFieldsValue({
            ...record,
        })
    }

    const handleDeleteRow = (id) => {
        /* 刪除單／多筆資料 */
        let data = []
        /* 將PK做成陣列 */
        if (id) {
            /* 當單筆刪除時會帶入id */
            data = [{
                class_id: id
            }]
            /* 放入欲刪除的陣列 */
        }

        else {
            data = selectedRowsInfo.map((val) => {
                /* 將已勾選的資料遍歷 */
                return {
                    class_id: val?.class_id
                }
                /* 取出pk放回陣列 */
            })
        }
        if (data.length > 0) {
            /* 防呆未勾選任何資料 */
            Modal.confirm({
                /* 一次性使用Modal且有確定與取消的按鈕 */
                content: '確定要刪除嗎？',
                /* modal內容 */
                onOk: () => {
                    deleteClassSetting(data)
                    /* 當按下確定後觸發刪除資料 */
                },
                okText: '確定',
                /* 確定的按鈕顯示的文字 */
                cancelText: '取消',
                /* 取消的按鈕顯示的文字 */
            })
        }
        else {
            message.info("請選擇項目")
            /* 一次性呈現上方提示字 */
        }
    }

    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.task_classification_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.task_classification_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                select_temp.push(record.task_classification_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.task_classification_id)
                selectRow = selectRow.filter(row => row.task_classification_id !== record.task_classification_id)
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const onCleanSelected = () => {
        setSelectedRowKeys([])
        setSelectedRowsInfo([])
    }

    const setParamsFilter = (obj) => {
        obj = trimObjectArray([obj]).find(_ => true);
        return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
    }
    const trimObjectArray = (data) => {
        return data.map(item => {
            // 创建一个新对象来避免修改原始对象
            const trimmedItem = {};
            for (const key in item) {
                if (Object.prototype.hasOwnProperty.call(item, key)) {
                    const value = item[key];
                    // 检查值是否为字符串
                    if (typeof value === 'string') {
                        trimmedItem[key] = value.trim();
                    } else {
                        trimmedItem[key] = value;
                    }
                }
            }
            return trimmedItem;
        });
    }

    const onFinish = ({ axiosMode, status, values }) => {
        propsOnFinish({ axiosMode, status, values });
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            if (axiosMode !== "get") {
                setModalLoading(false)
                setModalOpen(false)
            }
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                // actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                // actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                // actionRef.current.reloadAndRest();
            }
            // setModalLoading(false)
            // setModalOpen(false)
        }
    }

    const onFormFinish = (values) => {
        if (axiosMode === "post") {
            postClassSetting([values])
        }
        else if (axiosMode === "patch") {
            patchClassSetting([values])
        }
    }

    const onBefore = ({ axiosMode, status, values }) => {
        propsOnBefore({ axiosMode, status, values })
    }

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns
    })
    const {
        ClassSetting,
        getClassSetting,
        postClassSetting,
        patchClassSetting,
        deleteClassSetting,
    } = useClassSetting({
        onFinish,
        onBefore,
    })

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        getClassSetting();
    }

    useEffect(() => {
        checkAll();
        setDataInitialization();
    }, [])

    return (
        <>
            <Row gutter={[8, 8]}>
                <Col span={24}>
                    <ProTableOt
                        actionRef={actionRef}
                        columns={columns}
                        check={check}
                        setCheck={setCheck}
                        headerTitle={<></>}
                        request={async (params = {}, sort, filter) => {
                            let newParams = {
                            };
                            let order = setOrders(sort)
                            newParams = {
                                ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                ...newParams,
                                order,
                                size: params?.pageSize,
                                cur_page: params?.current,
                                custom_filter_value: params?.keyword,
                                custom_filter_key: custom_filter_key,
                            }
                            newParams = setParamsFilter({
                                ...newParams,
                            });
                            return getClassSetting({
                                ...newParams
                            })
                        }}
                        rowKey={'class_id'}
                        extra_columns={extra_columns}
                        set_extra_columns={set_extra_columns}
                        manage_columns={false}
                        scroll={{
                            // x: "max-content"
                        }}
                        toolBarRender={() => toolBarRender([
                            // <Button className='example' style={{ background: 'rgba(43, 193, 123, 1)', color: '#ffffff' }} onClick={e => exportRecord({ 'record_id_arr': selectedRowKeys })}>{t("export")}</Button>,
                            // <ImportButton
                            //     handleDownload={e => downloadRecord()}
                            //     handleImport={e => { e['columns'] = columns; importRecord(e) }}
                            //     set_upload_modal={set_upload_modal}
                            //     upload_modal={upload_modal}
                            //     importData={importData}
                            //     setImportData={setImportData}
                            //     import_modal={import_modal}
                            //     set_import_modal={set_import_modal}
                            //     handleReserve={e => patchRecord(e)}
                            //     handleOver={e => overRecord(e)}
                            //     columns={[...columns, {
                            //         title: '保留/覆蓋',
                            //         align: 'center',
                            //         render: (text, record, index) => {
                            //             if (record.type == 'name') {
                            //                 return (
                            //                     <>
                            //                         <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => { changeData(record) }}>保留</Button>
                            //                     </>)
                            //             } else if (record.type == 'both') {
                            //                 return (
                            //                     <>
                            //                         <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => { patchRecord([record]); changeData(record) }}>覆蓋</Button>
                            //                     </>
                            //                 )
                            //             }
                            //         }
                            //     }]}
                            // />,
                        ])}
                        rowSelection={{
                            type: 'checkbox',
                            selectedRowKeys: selectedRowKeys,
                            setSelectedRowKeys: setSelectedRowKeys,
                            selectedRowsInfo: selectedRowsInfo,
                            setSelectedRowsInfo: setSelectedRowsInfo,
                            ...rowSelection,
                        }}
                        tableAlertRender={({ selectedRowKeys, selectedRows }) => {
                            return (
                                <div className="space-y-4">
                                    <span>
                                        已選 {selectedRowKeys.length} 項
                                        <Typography.P style={{ marginInlineStart: 8 }}
                                            onClick={onCleanSelected}>
                                            取消選擇
                                        </Typography.P>
                                    </span>
                                </div>
                            );
                        }}
                        defaultSelectedRowsInfo={defaultSelectedRowsInfo}
                        defaultSelectedRowsKeys={defaultSelectedRowsKeys}
                        axiosMode={axiosMode}
                        propsUseData={() => {
                            return {
                                postData: (data) => {
                                    let datas = [...data]
                                    datas = datas.map((values) => {
                                        return values
                                    })
                                    postClassSetting(datas)
                                },
                                patchData: (data) => {
                                    patchClassSetting(data);
                                },
                                deleteData: deleteClassSetting,
                            }
                        }}
                        propsPatchOnFinish={({ axiosMode, status }) => {
                            if (status === "success") {
                                actionRef.current.reload()
                            } else {

                            }
                        }}
                        PropsPatchForm={<ClassSettingForm
                            keyPrefix={keyPrefix}
                            propsShowKeys={propsShowKeys}
                        />}
                        propsPatchOnBefore={() => { }}
                        propsPatch
                        modalOpen={modalOpen}
                        setModalOpen={setModalOpen}
                        propsDelete
                        propsPost
                        propsWidth={1000}
                    >
                    </ProTableOt>
                </Col>
            </Row>
        </>
    );
};
const ClassSettingForm = (
    {
        keyPrefix = "hrms.basic_data_maintain_management.class_setting_overview",
        propsForm,
        formReloadCount = 0,
        fieldName,
        defaultValue = [],
        propsOnValuesChange = () => { },
        onFormFinish = () => { },
        customFormItems = () => { },
        propsShowKeys = [
            { key: "record_id", name: "record_id", hidden: false, require: false },
            { key: "class_id", name: "class_id", hidden: false, require: false },
            { key: "class_name", name: "class_name", hidden: false, require: false },
            { key: "class_working_start_time", name: "class_working_start_time", hidden: false, require: false },
            { key: "class_working_end_time", name: "class_working_end_time", hidden: false, require: false },
            { key: "class_parent_id", name: "class_parent_id", hidden: false, require: false },
            { key: "action", name: "action", hidden: false, require: false },
        ],
        ...props
    }
) => {
    const keyPrefix_ = useContext(LanguageContext)
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix_ || keyPrefix })
    const [form_] = Form.useForm();
    const form = propsForm || form_
    const setFormValuesOtherThings = (formValues) => {
        // 做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        }
        form.setFieldsValue(newFormValues)
    }
    const getFormValues = () => {
        let values = {}
        values = form.getFieldsValue()
        return values
    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        getClassSetting({ "not_class_id": form.getFieldValue('class_id') })
    }
    const onValuesChange = (e, { name, ...props }) => {
        let formValues = getFormValues();
        propsOnValuesChange(formValues, { name, ...props })
    }
    const onFinish = () => {
        const values = getFormValues();
        onFormFinish({
            ...values,
        })
    }
    const { ClassSetting, getClassSetting } = useClassSetting({})
    useEffect(() => {
        setDataInitialization();
    }, [])
    useEffect(() => {
        let formValues = null
        formValues = form.getFieldsValue()
    }, [formReloadCount])
    useEffect(() => {
        if (defaultValue !== null && defaultValue.length !== 0) {
            form.setFieldsValue(defaultValue);
        }
    }, [defaultValue])
    return <>
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                name={"class_id"}
                            >
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                name="class_name"
                                label={t('class_name')}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                name="class_working_start_time"
                                label={t('class_working_start_time')}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <TimePickerForForm />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                name="class_working_end_time"
                                label={t('class_working_end_time')}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <TimePickerForForm />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                name="class_parent_id"
                                label={t('class_parent_name')}
                            >
                                <Select
                                    style={{
                                        maxHeight: "80vh",
                                        minHeight: "20vh",
                                        overflowX: "scroll",
                                        overflowY: "scroll",
                                    }}
                                    options={[{ class_name: "不分類", class_id: null }, ...ClassSetting].map(item => (
                                        {
                                            label: item?.class_name,
                                            value: item?.class_id,
                                        }
                                    ))}
                                />
                            </Form.Item>
                        </Col>
                        {customFormItems && customFormItems(fieldName, form.getFieldsValue(), onValuesChange, form)}
                    </Row>
                </Form>
            </Col>
        </Row>
    </>
}
export default ClassSettingOverView;